'use strict';exports.__esModule = true;exports.default =



















scrollTo;var _reactScroll = require('react-scroll');var isScrollRequireTempId = function isScrollRequireTempId(containerSelector, containerElement) {return containerSelector && containerElement && containerSelector.startsWith('.');};var scrollWithTempId = function scrollWithTempId(element, options, callback) {var containerId = 'TEMP_ID_FOR_SCROLL';element.setAttribute('id', containerId);callback(Object.assign({}, options, { containerId: containerId }));element.removeAttribute('id');};var smoothScroll = function smoothScroll(containerSelector, containerElement, scrollOffset, options, to, target) {var scroll = function scroll(opts) {return _reactScroll.animateScroll.animateTopScroll(scrollOffset, opts, to, target);};!isScrollRequireTempId(containerSelector, containerElement) ? scroll(options) : scrollWithTempId(containerElement, options, scroll);};function scrollTo(to, props) {
  var target = this.get(to);

  if (!target) {
    console.warn('target Element not found');
    return;
  }

  var options = Object.assign({},
  props, {
    absolute: false });


  if (_reactScroll.Events.registered.begin) {
    _reactScroll.Events.registered.begin(to, target);
  }

  var containerSelector = options.containerSelector;
  var containerElement = containerSelector ? document.querySelector(containerSelector) : null;

  var scrollOffset = void 0;

  if (containerSelector && containerElement) {
    options.absolute = true;
    if (containerElement !== target.offsetParent) {
      if (!containerElement.contains(target)) {
        throw new Error('Container with selector ' + containerSelector + ' is not a parent of target ' + to);
      }
    }

    scrollOffset = target.offsetTop;
  } else {
    var coordinates = target.getBoundingClientRect();
    scrollOffset = coordinates.top;
  }

  scrollOffset += options.offset || 0;

  if (!options.smooth) {
    if (containerSelector && containerElement) {
      containerElement.scrollTop = scrollOffset;
    } else {
      var bodyRect = document.body.getBoundingClientRect();
      window.scrollTo(0, scrollOffset - bodyRect.top);
    }

    if (_reactScroll.Events.registered.end) {
      _reactScroll.Events.registered.end(to, target);
    }

    return;
  }

  smoothScroll(containerSelector, containerElement, scrollOffset, options, to, target);
}module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/scrollTo.js
// module id = 173
// module chunks = 0